export function loadScript(url) {
  function request() {
    return new Promise((resolve, reject) => {
      let sc = document.createElement('script')
      sc.type = 'text/javascript'
      sc.async = 'async'

      sc.onload = sc.onreadystatechange = function () {
        if (!this.readyState || /^(loaded|complete)$/.test(this.readyState)) {
          resolve()
          sc.onload = sc.onreadystatechange = null
        }
      }

      sc.onerror = function () {
        reject(new Error('load error'))
        sc.onerror = null
      }

      sc.src = url
      document.getElementsByTagName('head')[0].appendChild(sc)
    })
  }

  function timeout() {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        reject(new Error('timeout'))
      }, 5000)
    })
  }

  return Promise.race([request(), timeout()])
}
export default {
  loadScript
}
